import React from 'react';
import './styles.css';
import PrimarySection from './components/primarySection/index';
import SearchFlights from '../flights/search.flights.view';
import AnyQuestions from './components/anyQuestion';
import CarouselSevices from '../share/components/CarouselServices/CarouselSevices';

import useHome from '../../viewModels/home/home.viewModel';
import CardDestiny from './components/CardDestiny/CardDestiny';
import ListCardsTours from './components/ListCardTours/ListCardsTours';
import FindOut from './components/FindOut/FindOut';
import WantMore from './components/WantMore/WantMore';
function Home() {
  useHome();
  return (
    <div className='homeContainer'>
      <PrimarySection />
      <section className='homeFlightSection'>
        <SearchFlights accompanied={false} />
      </section>
      <section className='homeSectionCarrousel'>
        <p className='homeSectionCarrouselTitle'>En Wellezy encontraras</p>
        <CarouselSevices />
      </section>
      {/* <section className='homeSectionDoubleCardWrap'>
        <div className='homeSectionDoubleCard'>
          <CardRegisterNow type={types.company} />
          <CardRegisterNow type={types.person} />
        </div>
      </section> */}
      <CardDestiny/>
      <ListCardsTours/> 
      <FindOut/>
      <WantMore/>
      <AnyQuestions title="¿Tienes alguna duda?" />
    </div>
  )
}
export default Home;